export const NOMINATED_RE_KYB = [
  // "870961", // test CID, need to be removed on production
  "40461",
  "10416",
  "25679",
  "71697",
  "58970",
  "27022",
  "28851",
  "44787",
  "5380",
  "17410",
  "55053",
  "35553",
  "404",
  "41615",
  "44525",
  "43837",
  "31339",
  "20998",
  "50433",
  "24958",
  "25190",
  "16363",
  "32757",
  "39967",
  "7227",
  "43714",
  "1623",
  "13503",
  "9175",
  "12472",
  "43780",
  "47945",
  "21280",
  "5014",
  "21791",
  "46134",
  "43155",
  "34984",
  "4643",
  "5170",
  "40641",
  "53419",
  "43216",
  "71888",
  "41341",
  "36747",
  "31277",
  "45079",
  "65083",
  "29497",
  "559",
  "43213",
  "46248",
  "48175",
  "643",
  "52313",
  "40313",
  "40553",
  "43853",
  "43572",
  "18792",
  "46489",
  "41952",
  "46104",
  "39149",
  "43801",
  "43637",
  "45775",
  "52681",
  "44122",
  "28507",
  "22704",
  "40089",
  "361",
  "34588",
  "41588",
  "39763",
  "46344",
  "43654",
  "26149",
  "496",
  "46351",
  "670",
  "39690",
  "46448",
  "46818",
  "44773",
  "13719",
  "63152",
  "49427",
  "45009",
  "42540",
  "52581",
  "50708",
  "16840",
  "4563",
  "49733",
  "904",
  "46214",
  "52653",
  "44130",
  "21924",
  "24524",
  "41028",
  "44779",
  "40413",
  "41849",
  "592",
  "40977",
  "42092",
  "46131",
  "44508",
  "70158",
  "54847",
  "17357",
  "60694",
  "627",
  "46103",
  "42167",
  "42040",
  "51809",
  "10218",
  "1832",
  "52322",
  "71458",
  "52758",
  "48736",
  "52860",
  "47108",
  "39739",
  "48259",
  "45894",
  "3170",
  "51530",
  "531",
  "46477",
  "17074",
  "44647",
  "53930",
  "16502",
  "46146",
  "27347",
  "49813",
  "46606",
  "39692",
  "39771",
  "27615",
  "47002",
  "51837",
  "22596",
  "39393",
  "44247",
  "27351",
  "46132",
  "43992",
  "46240",
  "49396",
  "44819",
  "63536",
  "44600",
  "23697",
  "45637",
  "61334",
  "47797",
  "40866",
  "40940",
  "30500",
  "60770",
  "40625",
  "44542",
  "7624",
  "46431",
  "48498",
  "72963",
  "44790",
  "33429",
  "23944",
  "36959",
  "33055",
  "45050",
  "43920",
  "50025",
  "40677",
  "14151",
  "45641",
  "72525",
  "48543",
  "52607",
  "52854",
  "12392",
  "55599",
  "26229",
  "72661",
  "72662",
  "37468",
  "40956",
  "71926",
  "15742",
  "49389",
  "43706",
  "658",
  "39414",
  "72222",
  "45587",
  "53411",
  "46152",
  "44681",
  "70446",
  "73050",
  "41701",
  "58462",
  "51690",
  "51991",
  "46097",
  "54314",
  "15957",
  "618",
  "62897",
  "40643",
  "13198",
  "52092",
  "58118",
  "39781",
  "5889",
  "41365",
  "49095",
  "35497",
  "15228",
  "400",
  "35778",
  "44843",
  "14112",
  "31392",
  "21395",
  "44745",
  "55755",
  "23513",
  "43610",
  "48412",
  "62074",
  "13647"
];
